export const routePermissions = {
    '/admin-list': 'list admin',
    '/supervisor-list': 'list admin',
    '/agent-list': 'list admin',
    '/customer-list': 'list customer',
    '/customer-account': 'list customer',
    '/customer-create': 'list customer',
    '/sim-list': 'list sim dashboard',
    '/sim': 'list sim dashboard',
    '/role-list': 'list role',
    '/role': 'list role',
    '/settings': 'list admin',
    '/countries': 'list countries',
    '/cities': 'list countries',
    '/states': 'list countries',
    '/country-create': 'list countries',
    '/city-create': 'list countries',
    '/user-types': 'list user type',
    '/user-types/': 'list user type',
    '/users-management': 'list user',
    '/user-account': 'list user',
    '/team-list': 'list user',
    '/team': 'list user',
    '/team-create': 'list user',
    '/organization-chart': 'view organization structure',
};

export const alwaysAccessible = [
    '/my-account',
    '/login',
    '/set-password',
    '/forgot-password',
    '/error',
    
    '/'
];

export const hasPermission = (requiredPermission) => {
    const permissions = localStorage.getItem('permissions');
    if (!permissions) return false;
    
    const permissionList = permissions.split(',').map(item => item.trim());
    return permissionList.includes(requiredPermission);
};

export const checkRoutePermission = (pathname) => {
    // Check if route is always accessible
    if (alwaysAccessible.includes(pathname)) {
        return true;
    }

    // Check for dynamic routes (remove parameters)
    const basePath = pathname.split('/').slice(0, -1).join('/') || pathname.split('/')[1];
    const baseRoute = '/' + basePath.replace('/', '');
    
    // Check exact match first
    if (routePermissions[pathname]) {
        return hasPermission(routePermissions[pathname]);
    }
    
    // Check base route
    if (routePermissions[baseRoute]) {
        return hasPermission(routePermissions[baseRoute]);
    }
    
    // Check for partial matches
    for (const route in routePermissions) {
        if (pathname.startsWith(route)) {
            return hasPermission(routePermissions[route]);
        }
    }

    // If route is not defined in permissions, deny access
    return false;
};